import axios from 'axios';
import _remove from 'lodash/remove';

import config from 'config.js';

// Constants
const GET_TEMPLATES_REQUEST = '_themes/GET_TEMPLATES_REQUEST';
const GET_TEMPLATES_SUCCESS = '_themes/GET_TEMPLATES_SUCCESS';
const GET_TEMPLATES_FAILURE = '_themes/GET_TEMPLATES_FAILURE';

const endpoitInitialStatus = {
  loading: false,
  error: false,
  success: false
};

const getCategories = (templates) => {
  let categories = templates.map((template) => template.category);

  categories = categories.filter((value, index, self) => self.map(x => x._id).indexOf(value._id) === index);

  return categories;
};

// Initiual State
const initialState = {
  templates: [],
  categories: [],

  getTemplates: { ...endpoitInitialStatus }
};

const getEndpointStatus = (type) => {
  const types = {
    request: {
      loading: true,
      error: false,
      success: false
    },
    success: {
      loading: false,
      error: false,
      success: true
    },
    failure: {
      loading: false,
      error: true,
      success: false
    },
  };

  return types[type];
};

// Reducer
export default function reducer(state = JSON.parse(JSON.stringify(initialState)), action = {}) {
  // getTemplates
  if (action.type === GET_TEMPLATES_REQUEST) {
    state.getTemplates = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === GET_TEMPLATES_SUCCESS) {
    state.getTemplates = getEndpointStatus('success');
    state.templates = action.payload;
    state.categories = getCategories(action.payload);

    return { ...state };
  }

  if (action.type === GET_TEMPLATES_FAILURE) {
    state.getTemplates = getEndpointStatus('failure');

    return { ...state };
  }

  return state;
}

// Action Creators
export function getTemplates() {
  const request = () => { return { type: GET_TEMPLATES_REQUEST } };
  const success = (data) => { return { type: GET_TEMPLATES_SUCCESS, payload: data } };
  const failure = () => { return { type: GET_TEMPLATES_FAILURE } };

  return async (dispatch, getState) => {
    dispatch(request());

    const state = getState();
    const response = await services.getTemplates(state._users.token);

    if (response) {
      return dispatch(success(response));
    } else {
      return dispatch(failure());
    }
  };
}

const services = {
  getTemplates: async (token) => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${config.apiUrl}/templates`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      return response.data;
    } catch (e) {
      return false;
    }
  }
};
